module.exports = __webpack_public_path__ + "static/kasuien01-a320c8d054b7b606e0a7b64bb61331be.jpg";